import NavbarItem, { NavbarItemProps } from "./NavbarItem";

export default function Navbar() {
	const items: NavbarItemProps[] = [
		{
			label: "Преимущества",
			href: "/",
		},
		{
			label: "Как подключиться",
			href: "/",
		},
		{
			label: "Тарифы",
			href: "/",
		},
		{
			label: "ЧаВо",
			href: "/",
		},
	];

	return (
		<nav className="flex flex-row gap-1">
			{items.map((item, i) => (
				<NavbarItem key={i} {...item} />
			))}
		</nav>
	);
}
